import styled from "styled-components";

const Text = styled.h4`
    text-align: center;
    padding: 2rem;
    color: #ffffff;
    border-bottom: solid #ffcf00 2px;
`;

function Final() {
    return <Text>Você chegou no final!</Text>;
}

export default Final;
